import clsx from "clsx";
import { Icon } from "../icons";
import { useModalContext } from "./context";

export function ModalCloseButton() {
	/** Context */
	const { onClose } = useModalContext();

	/** Render */
	return (
		<div
			className={clsx(
				"top-0 right-0 absolute opacity-50 hover:opacity-100 p-3 cursor-pointer",
				"text-black dark:text-white",
			)}
			onClick={onClose}
			onKeyUp={onClose}
		>
			<Icon name="X" />
		</div>
	);
}
